// Modules
import styled from 'styled-components';

// Styles
import { Body, BodyBoldTwo } from '../../styles/common/typo.styles';

// Types
import { styledComponentProps } from '../../types/theme';

export const Contact = styled.div`
	display: flex;
	background: ${({ theme }: styledComponentProps): string =>
		theme.colors.ui.paleGreen};
	line-height: 1;
	text-decoration: none;
	width: 100%;
	padding: 17px 30px 20px 30px;

	@media ${({ theme }: styledComponentProps): string => theme.breakpoints.lg} {
	  flex-direction: column;
	  align-items: center;
	  background: transparent
	}
`;

export const ContactIcon = styled.img<any>`
	width: 44px;
	height: 44px;
	margin-left: 8px !important;

	${({ direction }: styledComponentProps): string => {
		if (direction === 'ltr') {
			return `margin-right: 8px !important; margin-left: 0px`;
		}
		return '';
	}};
	transition: 0.2s all ease-in;
	${({ direction, hover }: styledComponentProps): string => {
		return direction === 'rtl'
			? `margin-left: ${hover ? -0.5 : 0}rem;`
			: `margin-right: ${hover ? -0.5 : 0}rem;`;
	}}

	@media ${({ theme }: styledComponentProps): string => theme.breakpoints.lg} {
	margin-bottom: 8px;
			  }
`;

export const P = styled(Body)<any>`
	color: ${({ theme }: styledComponentProps): string =>
		theme.colors.ui.barIlanGreen};

		@media ${({ theme }: styledComponentProps): string => theme.breakpoints.lg} {
	text-align: center;
		  }
`;

export const Link = styled.a<any>`
	color: ${({ theme }: styledComponentProps): string =>
		theme.colors.ui.jungleGreen};
	text-decoration: underline;
	cursor: pointer;

	@media ${({ theme }: styledComponentProps): string => theme.breakpoints.lg} {
		text-align: center;
			  }
`;

export const PBold = styled(BodyBoldTwo)`
	margin-bottom: 8px;
	color: ${({ theme }: styledComponentProps): string =>
		theme.colors.ui.barIlanGreen};

		@media ${({ theme }: styledComponentProps): string => theme.breakpoints.lg} {
			text-align: center;
				  }
`;
